import { useFormContext } from 'react-hook-form'
import { Input } from '../ui/Input'
import type { FormData } from './FormWizard'

export function StepContact() {
  const { register, formState: { errors } } = useFormContext<FormData>()

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          How can we reach you?
        </h2>
        <p className="text-gray-600">
          Brian will personally follow up within 24 hours
        </p>
      </div>

      <div className="space-y-4">
        <Input
          {...register('name', { 
            required: 'Please enter your name',
            minLength: { value: 2, message: 'Name is too short' },
          })}
          label="Full Name"
          placeholder="John Doe"
          autoComplete="name"
          error={errors.name?.message}
          required
        />

        <Input
          {...register('email', {
            required: 'Please enter your email',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Please enter a valid email address',
            },
          })}
          label="Email Address"
          type="email"
          placeholder="john@example.com"
          autoComplete="email"
          error={errors.email?.message}
          required
        />

        <Input
          {...register('phone', {
            pattern: {
              value: /^[\d\s\-()+]+$/,
              message: 'Please enter a valid phone number',
            },
          })}
          label="Phone Number"
          type="tel"
          placeholder="(805) 555-1234"
          autoComplete="tel"
          error={errors.phone?.message}
          hint="Optional, but helps us reach you faster"
        />
      </div>

      <div className="mt-6 p-4 bg-aquatic-50 rounded-xl border border-aquatic-100">
        <div className="flex items-start">
          <svg className="w-5 h-5 text-aquatic-600 mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <p className="text-sm text-aquatic-800">
            Your information is secure and will only be used to contact you about your aquarium needs. 
            We never share your data with third parties.
          </p>
        </div>
      </div>
    </div>
  )
}
